import { axiosInstance as axios } from "services";

export const updateAutoText = async (id, data) => {
  const { data: res } = await axios.patch(`/admin/proposalText/autoText/${id}`, data);
  if (!res.success) throw new Error(res.error || "Failed to update auto text");
  return res;
};

